import { Typography, styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(() => ({
    width: "100%",
    height: "100%",
}))

export const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
    marginTop: theme.spacing(5),
}))
